<app-list-loading content [items]="items">
    <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>{{ 'translate_parameter' | translate }}</th>
                        <th>{{ 'translate_category' | translate }}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    @for (item of items; track item; let index = $index) {
                        <tr>
                            <!-- Parameter -->
                            <td class="text-center">
                                {{ item.parameter.toUpperCase() }}
                            </td>
                            <!-- Category -->
                            <td>
                                {{ item.category.name }}
                            </td>
                            <!-- Controls -->
                            <td class="text-center">
                                <div
                                    class="flex flex-row items-center justify-center gap-2"
                                >
                                    <!-- Expand button -->
                                    <button
                                        class="action-icon action-icon-primary"
                                        (click)="toggle(item)"
                                        [appTooltip]="
                                            'translate_expand' | translate
                                        "
                                    >
                                        <i class="fa-light fa-plus"> </i>
                                    </button>
                                    <!-- Chart button -->
                                    <button
                                        class="action-icon action-icon-primary"
                                        (click)="showChart(item)"
                                        [appTooltip]="
                                            'translate_chart' | translate
                                        "
                                    >
                                        <i class="fa-light fa-chart-line"> </i>
                                    </button>
                                    <!-- Update button -->
                                    <button
                                        *appHasPermissionId="
                                            permissionList.kpiResultEntry
                                        "
                                        class="action-icon action-icon-edit"
                                        (click)="
                                            showUpdateDialog(
                                                item.category.id,
                                                item.parameter
                                            )
                                        "
                                        [appTooltip]="
                                            'translate_update' | translate
                                        "
                                    >
                                        <i class="fa-light fa-edit"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <!-- Subcategories & values -->
                        @if (
                            currentlyToggled.has(
                                item.parameter + item.category.id
                            )
                        ) {
                            <tr>
                                <td colspan="100%" class="!p-0">
                                    <div
                                        class="m-3 overflow-hidden rounded-xl border border-slate-200"
                                    >
                                        <!-- Header -->
                                        <div
                                            class="grid grid-cols-2 gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3"
                                        >
                                            <span
                                                class="text-xs font-semibold uppercase tracking-wide text-slate-500"
                                            >
                                                {{
                                                    'translate_subcategory'
                                                        | translate
                                                }}
                                            </span>
                                            <span
                                                class="text-center text-xs font-semibold uppercase tracking-wide text-slate-500"
                                            >
                                                {{
                                                    'translate_value'
                                                        | translate
                                                }}
                                            </span>
                                        </div>
                                        <!-- Rows -->
                                        <div class="divide-y divide-slate-100">
                                            @for (
                                                subcategory of item.values;
                                                track subcategory
                                            ) {
                                                <div
                                                    class="hover:bg-slate-50/50 grid grid-cols-2 items-center gap-3 px-4 py-3 transition-colors"
                                                >
                                                    <span
                                                        class="text-sm text-slate-700"
                                                    >
                                                        {{
                                                            subcategory
                                                                .subcategory
                                                                .name
                                                        }}
                                                    </span>
                                                    <span
                                                        class="text-center text-sm font-medium text-slate-600"
                                                    >
                                                        {{ subcategory.value }}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
    </div>
</app-list-loading>
